import { useAuth } from '@10000/react'
import { Avatar, Body, Box } from '../'
import { ItemPill } from './'
import './UserPill.scss'

export const UserPill = ({ user: { id, name, email, avatar, onboard }, invited, actionText, ...props }) => {
  const { user } = useAuth()

  return (
    <ItemPill {...props}>
      <Box fullWidth alignItems="center" gap={8} justifyContent="space-between">
        <Box gap={8} alignItems="center" className="pill-user">
          <Avatar size="small" index={avatar}/>
          {onboard
            ? <Body weight={600} alt size={16} overflow="ellipsis">{name}{user.id === id && ' (Me)'}</Body>
            : <Box column gap={8} className="pill-text-container">
              <Body size={12} weight={600} alt underline overflow="ellipsis" lineHeight="100%">{email}</Body>
              <Body size={12} lineHeight="100%">{invited ? '(Invite sent)' : '(Invite will be sent)'}</Body>
            </Box>
          }
        </Box>
        {actionText && <Body underline alt bold size={12}>{actionText}</Body>}
      </Box>
    </ItemPill>
  )
}